import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Tooltip,
  IconButton,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";
import formatDate from "../utilities/formatDate";
import editmodificationimg from "../assets/images/editmodificationimg.png";
import { faO } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import REPORT_BASE_URL from "../utilities/ReportConfig";


const TehsilVapsiTable = ( {data, dateselect} ) => {
  const [openPopup, setOpenPopup] = useState(false);
  const { userDetails } = useSelector((state) => state.auth);
  const [selectedRegNos, setSelectedRegNos] = useState([]);
  console.log(selectedRegNos)



const handleCheckboxChange = (regno, checked) => {
  setSelectedRegNos((prev) =>
    checked ? [...prev, regno] : prev.filter((r) => r !== regno)
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);

  // Add one day because UTC time may cause an off-by-one issue
  date.setDate(date.getDate());

  // Format as "12 Mar 2025"
  return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
  });
};

// Example usage
const inputDate = dateselect;
const formattedDate = formatDate(inputDate);

console.log(formattedDate); // Output: "12 Mar 2025"

const handleOkButtonClick = () => {
 

   // Format date correctly

  const reportUrl = `${REPORT_BASE_URL}/Report/VapasiRegisterTehsil.aspx?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&recptdate=${formattedDate}&regno=${selectedRegNos}`;

  window.open(reportUrl, "_blank"); 
  setSelectedRegNos("")

};



 
  debugger
  const TableData = Array.isArray(data)
    ? data?.map((item, index) => ({
        ...item,
        sn: index + 1,
      }))
    : [];

  console.log(TableData);
  const columns = [
    {
      name: "select",
      label: "Select",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const regno = tableMeta.rowData[1]; // Assuming regno is the second column (index 1)
          return (
            <input
              type="checkbox"
              checked={selectedRegNos.includes(regno)}
              onChange={(e) => handleCheckboxChange(regno, e.target.checked)}
            />
          );
        },
      },
    },
    {
      name: "regno",
      label: "Reg No",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "bookno",
      label: "Book No",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "120px",
            }}
            className="text-start text-xs md:text-xs 3xl:text-sm"
          >
            {value}
          </div>
        ),
      },
    },
    {
      name: "fparty",
      label: "First Party",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "120px",
            }}
            className="text-center text-xs md:text-sm"
          >
            {value}
          </div>
        ),
      },
    },
    {
      name: "secparty",
      label: "Second Party",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "location",
      label: "Location",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Tooltip title={value} arrow>
            <div
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "120px",
              }}
            >
              {value}
            </div>
          </Tooltip>
        ),
      },
    },
    {
      name: "property_no",
      label: "Property Details",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "sroname",
      label: "SRO Name",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "dname",
      label: "District",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-xs 3xl:text-sm">
            {formatDate(value, "dd/MM/yyyy")}
          </div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <Tooltip title={value} arrow>
            <div
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "120px",
              }}
            >
              {value}
            </div>
          </Tooltip>
        ),
      },
    },
  ];
  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, 
    print: false,
    viewColumns: false, 
    search: false,
    filter: false,
    customToolbar: () => {
      return (
        <>
          
            <Tooltip title="PRINT">
              <>
                <button
                  onClick={handleOkButtonClick}
                  className="bg-blue-400 text-white text-sm px-3 py-2 rounded hover:bg-blue-700 focus:outline-none inline-flex items-center gap-2"
                >
                  
                  PRINT
                </button>
              </>
            </Tooltip>
     
        </>
      );
    },
  };
  
 
   const getMuiTheme = () =>
     createTheme({
       typography: {
         fontFamily: "Poppins",
       },
       palette: {
         background: {
           paper: "#ffffff",
           default: "#ffffff",
         },
         mode: "light",
       },
       components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#CACACA !important",
              color: "#000000 !important",
              padding: "2px 1px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              fontSize: "12px", // Default font size
              textAlign: "start",
              whiteSpace: "nowrap", // Prevent text wrapping
              "@media (max-width: 768px)": {
                fontSize: "10px", // Reduce font size for small screens
              },
              "@media (max-width: 480px)": {
                fontSize: "8px", // Further reduce for extra small screens
              },
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#ffffff !important",
                backgroundColor: "#929292 !important",
              },
            },
            body: {
              padding: "3px 8px",
              color: "#000000",
              borderBottom: "1px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
        
         MuiInputBase: {
           styleOverrides: {
             root: {
               backgroundColor: "#F1F1F1", // Change search input background color
               borderRadius: "1px", // Optional: Add border-radius for better UI
               padding: "1px 5px",
               color: "#6A6A6A !important",
               borderBottom: "0px",
             },
           },
         },
       },
     });

  return (
    <>
      {/* {showVoucher && <VoucherPopup data={voucherData} attachmentData={attachmentData} openPopup={true} />}       */}
      <div className="py-2 flex">
        <Box width="100%">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              data={TableData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Box>
      </div>
    </>
  );
};

export default TehsilVapsiTable;
